import { memo, HTMLAttributes } from 'react';
import styles from './Bar.module.scss';

export type BarProps = {
    backgroundColor: string;
} & HTMLAttributes<HTMLDivElement>;

const Bar = ({ backgroundColor, style, ...props }: BarProps) => (
    <div
        style={{
            backgroundColor,
            ...style,
        }}
        className={styles.bar}
        {...props}
    />
);

export default memo(Bar);
